export const GenderEnum = {
  male: 'Masculino',
  female: 'Feminino',
  other: 'Outro',
  notDeclared: 'Não declarado',
};
